import { render, staticRenderFns } from "./CodeInput.vue?vue&type=template&id=13b64dda"
import script from "./CodeInput.vue?vue&type=script&lang=js"
export * from "./CodeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports